<!--
 * @Author: mercer
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2021-04-22 14:42:43
 * @Description: 
-->
<template>
  <div class="sidebar">
    <div class="sidebar-title">
      <h2>科隆云</h2>
      <div class="namezh">{{ $route.meta.namezh }}</div>
    </div>
    <Menu theme="dark" mode="horizontal" :active-name="$route.name" width="158px" style="flex-grow: 1">
      <Submenu name="我的">
        <template slot="title">
          <Icon type="ios-stats" />我的
        </template>
        <MenuItem name="task" to="/home/task">
        <Icon type="md-contacts" />任务
        </MenuItem>
      </Submenu>
      <!-- 客户管理 -->
      <Submenu name="客户管理" v-if="
        displayMenu.customer ||
        displayMenu.salesRecord ||
        displayMenu.tankRental ||
        displayMenu.sales_order ||
        displayMenu.tech_service ||
        displayMenu.receive
      ">
        <template slot="title">
          <Icon type="ios-stats" />客户管理
        </template>
        <MenuItem name="customer" v-if="displayMenu.customer" to="/home/customer">
        <Icon type="md-contacts" />客户
        </MenuItem>
        <MenuItem name="customerAnalyze" v-if="displayMenu.customerAnalyze" to="/home/customer_analyze">
        <Icon type="md-contacts" />客户分析
        </MenuItem>
        <MenuItem v-if="displayMenu.salesRecord" name="salesRecord" to="/home/salesRecord">
        <Icon type="md-contacts" />销售记录
        </MenuItem>
        <MenuItem v-if="displayMenu.tankRental" name="storageTank" to="/home/storageTank">
        <Icon type="md-contacts" />储罐列表
        </MenuItem>
        <MenuItem v-if="displayMenu.tankRental" name="tankRental" to="/home/tankRental">
        <Icon type="md-contacts" />储罐借用
        </MenuItem>
        <MenuItem v-if="displayMenu.sales" name="sales" to="/home/sales">
        <Icon type="md-contacts" />销售项目
        </MenuItem>
        <MenuItem v-if="displayMenu.sales" name="JDItemCodeCheck" to="/home/jd_item_code_check">
        <Icon type="md-contacts" />金蝶云物料核对
        </MenuItem>
        <MenuItem v-if="displayMenu.salesRecord" name="salesPlan" to="/home/salesPlan">
        <Icon type="md-contacts" />销售计划
        </MenuItem>
        <MenuItem v-if="displayMenu.tech_service" name="recipe" to="/home/recipe">
        <Icon type="md-contacts" />配方管理
        </MenuItem>

        <!-- <MenuItem
          v-if="displayMenu.sales_order"
          name="sales_contract"
          to="/home/sales_contract"
        >
          <Icon type="ios-color-filter" />销售合同
        </MenuItem>-->
        <MenuItem v-if="displayMenu.tech_service || displayMenu.finance" name="tech_service" to="/home/tech_service">
        <Icon type="ios-color-filter" />技术服务
        </MenuItem>
        <MenuItem v-if="displayMenu.tech_service || displayMenu.finance" name="tech_service_stat"
          to="/home/tech_service_stat">
        <Icon type="ios-color-filter" />技术统计
        </MenuItem>
        <MenuItem v-if="displayMenu.customer_develop" name="customer_develop" to="/home/customer_develop">
        <Icon type="ios-color-filter" />客户开发
        </MenuItem>
        <MenuItem v-if="displayMenu.customer_develop" name="import_customer_qz_table"
          to="/home/import_customer_qz_table">
        <Icon type="ios-color-filter" />权责表
        </MenuItem>
        <MenuItem v-if="displayMenu.customer_develop" name="customer_qz_review" to="/home/customer_qz_review">
        <Icon type="ios-color-filter" />权责审核
        </MenuItem>
        <MenuItem v-if="displayMenu.customer_contact" name="customer_contact" to="/home/customer_contact">
        <Icon type="ios-color-filter" />联系人
        </MenuItem>
        <MenuItem v-if="displayMenu.customer_contact" name="sales_promo_fee" to="/home/sales_promo_fee">
        <Icon type="ios-color-filter" />业务费
        </MenuItem>
        <MenuItem v-if="displayMenu.cacl_sales_cost" name="sales_order_profit" to="/home/sales_order_profit">
        <Icon type="ios-color-filter" />客户利润
        </MenuItem>
      </Submenu>
      <!-- 回款 -->
      <Submenu v-if="displayMenu.receive" name="回款">
        <template slot="title">
          <Icon type="ios-stats" />回款
        </template>
        <MenuItem v-if="displayMenu.receive" name="receiveChart" to="/home/receive_chart">
        <Icon type="md-contacts" />回款统计
        </MenuItem>
        <MenuItem v-if="displayMenu.arTable" name="importARTable" to="/home/importARTable">
        <Icon type="md-contacts" />账龄
        </MenuItem>
        <MenuItem v-if="displayMenu.receive" name="receive" to="/home/receive">
        <Icon type="md-contacts" />回款记录
        </MenuItem>
        <MenuItem v-if="displayMenu.arTable" name="receive_task" to="/home/receive_task">
        <Icon type="md-contacts" />回款任务
        </MenuItem>
        <MenuItem v-if="displayMenu.arTable" name="receive_task_stat" to="/home/receive_task_stat">
        <Icon type="md-contacts" />回款任务统计
        </MenuItem>
        <MenuItem v-if="displayMenu.arTable" name="duizhangdan_list" to="/home/duizhangdan_list">
        <Icon type="md-contacts" />对账单列表
        </MenuItem>
      </Submenu>
      <!-- 物料管理 -->
      <Submenu name="物料管理" v-if="
        displayMenu.raw_material ||
        displayMenu.semi_material ||
        displayMenu.product
      ">
        <template slot="title">
          <Icon type="ios-stats" />物料管理
        </template>
        <MenuItem v-if="displayMenu.raw_material" name="raw_material" to="/home/raw_material">
        <Icon type="md-contacts" />原材料
        </MenuItem>
        <MenuItem v-if="displayMenu.semi_material" name="semi_material" to="/home/semi_material">
        <Icon type="md-contacts" />母液
        </MenuItem>
        <MenuItem v-if="displayMenu.semi_material" name="semi_Item" to="/home/semi_Item">
        <Icon type="md-contacts" />母液项目
        </MenuItem>
        <MenuItem v-if="displayMenu.product" name="product" to="/home/product">
        <Icon type="md-contacts" />产品
        </MenuItem>
        <MenuItem v-if="displayMenu.cacl_purchase_cost" name="caclPurchase" to="/home/caclPurchase">
        <Icon type="md-contacts" />材料成本
        </MenuItem>
        <MenuItem v-if="user.superAdmin" name="caclMLCost" to="/home/caclMLCost">
        <Icon type="md-contacts" />母液成本
        </MenuItem>
        <MenuItem v-if="displayMenu.cacl_sales_cost" name="caclSalesCost" to="/home/caclSalesCost">
        <Icon type="md-contacts" />客户成本
        </MenuItem>
        <!-- <MenuItem v-if="displayMenu.cacl_sales_cost" name="calcCost" to="/home/calcCost">
          <Icon type="md-contacts" />成本核算
        </MenuItem> -->
      </Submenu>
      <!-- 销售订单 -->
      <Submenu v-if="displayMenu.sales_order" name="销售订单">
        <template slot="title">
          <Icon type="ios-stats" />销售订单
        </template>
        <MenuItem v-if="displayMenu.sales_order" name="sales_order" to="/home/sales_order">
        <Icon type="ios-color-filter" />销售订单
        </MenuItem>
        <MenuItem v-if="displayMenu.sales_order" name="sales_order_table" to="/home/sales_order_table">
        <Icon type="ios-color-filter" />销售订单列表
        </MenuItem>
        <MenuItem v-if="displayMenu.vehicle" name="vehicle" to="/home/vehicle">
        <Icon type="md-contacts" />车辆信息
        </MenuItem>
        <MenuItem v-if="displayMenu.sales_prod_order" name="sales_prod_order" to="/home/sales_prod_order">
        <Icon type="md-contacts" />销售生产订单
        </MenuItem>
        <MenuItem v-if="displayMenu.sales_order" name="sales_order_vol" to="/home/sales_order_vol">
        <Icon type="ios-color-filter" />销量统计
        </MenuItem>
      </Submenu>
      <!-- 机构 -->
      <Submenu v-if="displayMenu.purchase" name="机构">
        <template slot="title">
          <Icon type="ios-stats" />机构
        </template>

        <MenuItem v-if="displayMenu.purchase" name="supplier" to="/home/supplier">
        <Icon type="md-contacts" />供应商
        </MenuItem>
        <MenuItem v-if="displayMenu.purchase" name="entity" to="/home/entity">
        <Icon type="md-contacts" />机构
        </MenuItem>
      </Submenu>

      <!-- 财务管理 -->
      <Submenu v-if="displayMenu.finance_sales" name="财务管理">
        <template slot="title">
          <Icon type="ios-stats" />财务管理
        </template>
        <MenuItem v-if="displayMenu.purchase" name="payment" to="/home/payment">
        <Icon type="md-contacts" />付款记录
        </MenuItem>
        <MenuItem v-if="displayMenu.finance" name="bankAccount" to="/home/bank_account">
        <Icon type="md-contacts" />收款账号
        </MenuItem>
        <MenuItem v-if="displayMenu.finance_sales" name="bill" to="/home/bill">
        <Icon type="md-contacts" />票据
        </MenuItem>
        <MenuItem v-if="displayMenu.finance_sales" name="importFileProcess" to="/home/importFileProcess">
        <Icon type="md-contacts" />出库单
        </MenuItem>
        <MenuItem v-if="displayMenu.finance_sales" name="outStoreStat" to="/home/outStoreStat">
        <Icon type="md-contacts" />出库单统计
        </MenuItem>
      </Submenu>

      <!-- 财务管理 -->
      <Submenu v-if="
        displayMenu.company_setting || displayMenu.factory || displayMenu.user
      " name="公司设置">
        <template slot="title">
          <Icon type="ios-stats" />公司设置
        </template>
        <MenuItem v-if="displayMenu.company_setting" name="company" to="/home/company">
        <Icon type="md-contacts" />公司
        </MenuItem>
        <MenuItem v-if="displayMenu.factory" name="factory" to="/home/factory">
        <Icon type="md-contacts" />工厂
        </MenuItem>
        <MenuItem name="usermanagement" v-if="displayMenu.user" to="/home/usermanagement">
        <Icon type="md-contacts" />用户和权限
        </MenuItem>
      </Submenu>
    </Menu>
    <Dropdown @on-click="goUserPage" v-if="user" trigger="click" style="
        margin-left: auto;
        padding-right: 12px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        background: #515a6e;
        color: #fff;
      " placement="bottom-end">
      <span>
        {{ user.name }}
        <Icon type="ios-arrow-down"></Icon>
      </span>
      <DropdownMenu slot="list">
        <DropdownItem name="setting">个人设置</DropdownItem>
        <DropdownItem name="changPassword">修改密码</DropdownItem>
        <DropdownItem name="logout" style="color: red">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Modal v-model="logoutModal" @on-ok="logoutFunc" width="300" okText="确认退出">
      <h3>确认退出登录？</h3>
    </Modal>
    <Modal v-model="changePasswordModal" title="修改用户密码" width="300">
      <Form ref="changePasswordForm" :model="changePasswordForm" :rules="changePasswordValidate">
        <FormItem label="请输入旧密码" prop="oldPassword">
          <Input v-model="changePasswordForm.oldPassword" placeholder="旧密码"></Input>
        </FormItem>
        <FormItem label="请输入新密码" prop="newPassword">
          <Input v-model="changePasswordForm.newPassword" placeholder="新密码"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitChangePassword('changePasswordForm')">确定修改</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { arrayIntersection } from "@/utils";
import { mapState, mapActions } from "vuex";

export default {
  name: "AppSidebar",
  data() {
    const validtNewPassword = (rule, value, cb) => {
      const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,20}$/;
      if (!reg.test(value)) {
        cb(new Error("密码必须由数字和字母组成"));
      } else {
        cb();
      }
    };
    return {
      logoutModal: false,
      changePasswordModal: false,
      confirmChangeModal: false,
      changePasswordValidate: {
        oldPassword: [
          { required: true, message: "请填写旧密码", trigger: "blur" },
          {
            type: "string",
            min: 8,
            message: "密码必须大于8位数",
            trigger: "blur"
          }
        ],
        newPassword: [
          { required: true, message: "请填写新密码", trigger: "blur" },
          {
            type: "string",
            min: 8,
            message: "密码必须大于8位数",
            trigger: "blur"
          },
          {
            validator: validtNewPassword,
            trigger: "blur"
          }
        ]
      },
      changePasswordForm: {
        newPassword: "",
        oldPassword: ""
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.currentUser
    }),
    displayMenu: function () {
      return {
        customerAnalyze:
          this.user.superAdmin ||
          arrayIntersection(["salesAssist", "salesLead"], this.user.simpleRole)
            .length > 0,
        customer:
          this.user.superAdmin ||
          arrayIntersection(["sales", "salesAssist", "salesLead"], this.user.simpleRole)
            .length > 0,
        salesRecord:
          this.user.superAdmin ||
          arrayIntersection(
            ["salesAssist", "sales", "salesLead"],
            this.user.simpleRole
          ).length > 0,
        sales:
          this.user.superAdmin ||
          arrayIntersection(
            [
              "productionWorkers",
              "technology",
              "technologyLead",
              "techLead",
              "salesAssist",
              "factoryLeader",
              "allFactoryLeader",
              "deliveryLeader",
              "deliveryAssist",
              "sales",
              "salesLead"
            ],
            this.user.simpleRole
          ).length > 0,
        receive:
          this.user.superAdmin ||
          arrayIntersection(
            ["salesAssist", "sales", "salesLead", "acct", "acctManager"],
            this.user.simpleRole
          ).length > 0,
        sales_order:
          this.user.superAdmin ||
          arrayIntersection(
            [
              "sales",
              "salesLead",
              "factoryLeader",
              "deliveryLeader",
              "allFactoryLeader",
              "deliveryAssist"
            ],
            this.user.simpleRole
          ).length > 0,
        finance:
          this.user.superAdmin ||
          arrayIntersection(["acctManager"], this.user.simpleRole).length > 0,
        finance_sales:
          this.user.superAdmin ||
          arrayIntersection(["acctManager", "salesLead"], this.user.simpleRole)
            .length > 0,
        cacl_purchase_cost:
          this.user.superAdmin ||
          arrayIntersection(["purchase", "purchaseLead"], this.user.simpleRole)
            .length > 0,
        purchase:
          this.user.superAdmin ||
          arrayIntersection(
            ["purchase", "purchaseLead", "acctManager", "acct"],
            this.user.simpleRole
          ).length > 0,
        cacl_sales_cost:
          this.user.superAdmin ||
          arrayIntersection(["salesLead", "salesAssist"], this.user.simpleRole)
            .length > 0,
        tech_service:
          this.user.superAdmin ||
          arrayIntersection(
            [
              "technologyLead",
              "salesAssist",
              "sales",
              "salesLead",
              "technology"
            ],
            this.user.simpleRole
          ).length > 0,
        customer_develop:
          this.user.superAdmin ||
          arrayIntersection(
            ["salesDirector", "salesAssist", "sales", "salesLead"],
            this.user.simpleRole
          ).length > 0,
        customer_contact:
          this.user.superAdmin,
        raw_material:
          this.user.superAdmin ||
          arrayIntersection(
            [
              "purchase",
              "purchaseLead",
              "factoryLeader",
              "allFactoryLeader",
              "technologyLead",
              "technology",
              "semiRecipe"
            ],
            this.user.simpleRole
          ).length > 0,
        semi_material:
          this.user.superAdmin ||
          arrayIntersection(
            [
              "technologyLead",
              "technology",
              "factoryLeader",
              "allFactoryLeader"
            ],
            this.user.simpleRole
          ).length > 0,
        product:
          this.user.superAdmin ||
          arrayIntersection(
            [
              "technologyLead",
              "technology",
              "salesAssist",
              "factoryLeader",
              "allFactoryLeader"
            ],
            this.user.simpleRole
          ).length > 0,
        sales_prod_order:
          this.user.superAdmin ||
          arrayIntersection(
            [
              "factoryLeader",
              "deliveryLeader",
              "productionWorkers",
              "deliveryAssist",
              "allFactoryLeader"
            ],
            this.user.simpleRole
          ).length > 0,
        material_cost: this.user.superAdmin,
        vehicle:
          this.user.superAdmin ||
          arrayIntersection(
            ["factoryLeader", "deliveryLeader", "deliveryAssist"],
            this.user.simpleRole
          ).length > 0,
        company_setting: this.user.superAdmin,
        dashboard:
          this.user.superAdmin ||
          arrayIntersection(["salesAssist"], this.user.simpleRole).length > 0,
        task:
          this.user.superAdmin ||
          arrayIntersection(["salesAssist"], this.user.simpleRole).length > 0,
        sac:
          this.user.superAdmin ||
          arrayIntersection(
            ["allFactoryLeader", "factoryLeader"],
            this.user.simpleRole
          ).length > 0,
        factory: this.user.superAdmin,
        user:
          this.user.superAdmin ||
          arrayIntersection(["hr"], this.user.simpleRole).length > 0,
        tankRental:
          this.user.superAdmin ||
          arrayIntersection(
            ["salesAssist", "sales", "salesLead"],
            this.user.simpleRole
          ).length > 0,
        sacCompany: this.user.superAdmin,
        arTable:
          this.user.superAdmin ||
          arrayIntersection(["salesLead", "acctManager", "sales", "acct"], this.user.simpleRole)
            .length > 0
      };
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions({
      logout: "auth/logoutAction",
      resetMyPassword: "user/resetMyPasswordAction"
    }),
    goUserPage: function (name) {
      switch (name) {
        case "setting":
          this.$router.push("user");
          break;
        case "changPassword":
          this.changePasswordModal = true;
          break;
        case "logout":
          this.logoutModal = true;
          break;
      }
    },
    async logoutFunc() {
      try {
        await this.logout();
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
      this.$router.push("/");
    },
    // 修改密码提交
    async submitChangePassword(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          if (
            this.changePasswordForm.oldPassword ===
            this.changePasswordForm.newPassword
          ) {
            this.$Message.error("新旧密码不能重复!");
          } else {
            try {
              await this.resetMyPassword({
                password: this.changePasswordForm.newPassword,
                oldPassword: this.changePasswordForm.oldPassword
              });
              this.changePasswordModal = false;
              this.$Message.success("修改成功!");
            } catch (error) {
              this.$Message.error(error);
            }
          }
        } else {
          this.$Message.error("修改失败!");
        }
      });
    }
  }
};
</script>

<style lang="stylus">
.sidebar
  width 100%
  display flex
  position fixed
  border-style solid
  border-color #dcdee2
  border-width 0 1px 0 0
  z-index 999
  // overflow auto

.sidebar-title
  padding 0px 30px
  height 40px
  display flex
  align-items center
  background-color #2D8CF0
  color #fff

.namezh
  margin 0px 0 0 12px
  font-size 14px

.ivu-menu-vertical.ivu-menu-light::after
  display none !important

.ivu-menu-horizontal
  height 40px
  line-height 40px

.ivu-menu-item-group-title
  padding-left 20px !important
  margin 20px 0 10px 0
  height 16px !important
  line-height 16px !important
  color #001737 !important
  font-weight 500

.ivu-menu-item
  height 30px
  line-height 30px !important
  padding 0 20px !important
</style>
